<template>
  <v-container class="main-card mt-2">
    <v-row>
      <v-col cols="12">
        <div class="text-overline">Settings</div>
      </v-col>
    </v-row>
    <!-- banner that you have started the reviewer enrollment process but there is some stuff left to do -->
    <v-row
      v-if="
        !settingsErrorMsg &&
        isReviewer &&
        (!reviewerProfileExperienceOk ||
          !reviewerProfileLinkedinUrlOk ||
          !reviewerProfilePaymentsOk)
      "
    >
      <v-col cols="12">
        <v-alert
          type="info"
          outlined
          icon="mdi-information"
          class="mb-2"
          v-if="!settingsLoading"
        >
          <v-row align="center">
            <v-col class="grow">
              Looks like you've started reviewer enrollment but there's some
              stuff left to do - see the checklist below in the
              <b>Reviewer Profile</b> section.
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        v-if="settingsLoading"
        style="height: 50vh"
        class="d-flex justify-center align-center"
      >
        <v-progress-circular :size="50" class="m" indeterminate color="primary">
        </v-progress-circular>
      </v-col>
      <v-col
        cols="12"
        v-if="!settingsLoading && settingsErrorMsg != ''"
        style="height: 50vh"
        class="d-flex justify-center align-center"
      >
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center ma-0 pa-0">
            <v-icon x-large color="red darken-2">
              mdi-alert-circle-outline
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center ma-0 pa-0">
            {{ settingsErrorMsg }}
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center mt-2">
            <v-btn large color="primary" @click="getSettings()"> Retry </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="my-0 py-0"
        v-if="!settingsLoading && settingsErrorMsg == ''"
      >
        <v-card class="mt-2 mb-2">
          <v-app-bar flat color="rgba(0, 0, 0, 0)">
            <v-toolbar-title class="text-overline">Profile</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-card-text>
            <v-row>
              <v-col cols="3" class="pt-2 pb-2">
                <span class="font-weight-medium">Email</span>
              </v-col>
              <v-col cols="9" class="pt-2 pb-2">
                <p>{{ userEmail }}</p>
              </v-col>
              <v-col cols="3" class="pt-2 pb-2">
                <span class="font-weight-medium">Password</span>
              </v-col>
              <v-col cols="9" class="pt-2 pb-2">
                <v-btn small @click="dialog = true">Change password</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        class="my-0 py-0"
        v-if="!settingsLoading && settingsErrorMsg == ''"
      >
        <v-card class="mt-2 mb-2">
          <v-card-title class="text-overline"> Subscription </v-card-title>
          <v-card-text>
            <!-- no subscription -->
            <v-row v-if="!isPro">
              <v-col cols="12">
                <p>You do not have any active subscription.</p>
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" to="/gopro">Upgrade to Pro</v-btn>
              </v-col>
            </v-row>
            <!-- active subscription -->
            <v-row v-if="isPro">
              <v-col cols="12" class="mb-0 pb-0">
                <v-chip
                  color="warning"
                  class="white--text"
                  small
                  v-if="proSubscription.Cancelled"
                >
                  Cancelled
                </v-chip>
                <v-chip
                  color="info"
                  class="white--text"
                  small
                  v-if="
                    !proSubscription.Cancelled && proSubscription.Cancelling
                  "
                >
                  Processing cancellation...
                </v-chip>
                <v-chip
                  color="green"
                  class="white--text"
                  small
                  v-if="
                    !proSubscription.Cancelled && !proSubscription.Cancelling
                  "
                >
                  Active
                </v-chip>
              </v-col>
              <v-col cols="12" v-if="proSubscription.Cancelled">
                <span>
                  Your subscription has been cancelled. You can still enjoy all
                  Pro features of your plan until:
                  {{
                    $utils.detailedTimeFromTs(proSubscription.ValidUntilEpochMs)
                  }}
                </span>
              </v-col>
              <v-col
                cols="12"
                v-if="!proSubscription.Cancelled && proSubscription.Cancelling"
              >
                <span>
                  Your subscription cancellation is being processed.
                </span>
              </v-col>
              <!-- <v-col
                cols="12"
                class="mt-2 pt-0 mb-0 pb-0"
                v-if="!proSubscription.Cancelled"
              >
                <span class="font-weight-medium">Current plan:</span>
                {{ proSubscription.Option }}
              </v-col> -->
              <v-col
                cols="12"
                class="mt-1 pt-0 mb-2 pb-0"
                v-if="!proSubscription.Cancelled && !proSubscription.Cancelling"
              >
                <span class="font-weight-medium">Next billing date:</span>
                {{
                  $utils.detailedTimeFromTs(proSubscription.ValidUntilEpochMs)
                }}
              </v-col>
              <v-col cols="12" v-if="!proSubscription.Cancelled">
                <v-btn
                  :disabled="proSubscription.Cancelling"
                  color="warning"
                  small
                  @click="cancelSubscription"
                  :loading="cancelSubscriptionLoading"
                >
                  Cancel subscription
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="4"
        md="6"
        class="my-0 py-0"
        v-if="!settingsLoading && settingsErrorMsg == '' && isReviewer"
      >
        <v-card class="mt-2 mb-2">
          <v-app-bar flat color="rgba(0, 0, 0, 0)">
            <v-toolbar-title class="text-overline"
              >Reviewer profile</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-card-text>
            <div>
              <v-row>
                <v-col cols="3" class="pt-2 pb-0 mb-0">
                  <p>Status:</p>
                </v-col>
                <v-col cols="9" class="pt-2 pb-0 mb-0">
                  <v-chip
                    :color="reviewerStatus === 'active' ? 'green' : 'orange'"
                    text-color="white"
                    small
                  >
                    {{ reviewerStatus }}
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </div>
            <v-list dense>
              <!-- <v-col cols="12" class="mt-1 mb-1 pt-0 pb-0">
                <a
                  href="/reviewer-enrollment/step1?chained=true"
                  class="text-decoration-none"
                >
                  Begin setting up your reviewer profile
                </a>
              </v-col> -->
              <v-list-item-group color="primary">
                <v-list-item to="/reviewer-enrollment/step1">
                  <v-list-item-icon>
                    <v-icon color="green" v-if="reviewerProfileExperienceOk">
                      mdi-check-circle-outline
                    </v-icon>
                    <v-icon v-if="!reviewerProfileExperienceOk">
                      mdi-radiobox-blank
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Experience</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item to="/reviewer-enrollment/step2">
                  <v-list-item-icon>
                    <v-icon color="green" v-if="reviewerProfileLinkedinUrlOk">
                      mdi-check-circle-outline
                    </v-icon>
                    <v-icon v-if="!reviewerProfileLinkedinUrlOk">
                      mdi-radiobox-blank
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Linkedin url</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item to="/reviewer-enrollment/step3">
                  <v-list-item-icon>
                    <v-icon color="green" v-if="reviewerProfilePaymentsOk">
                      mdi-check-circle-outline
                    </v-icon>
                    <v-icon v-if="!reviewerProfilePaymentsOk">
                      mdi-radiobox-blank
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Setup payment profile</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-btn
              outlined
              block
              color="blue"
              class="mt-2"
              to="/reviewer-dashboard"
            >
              Reviewer dashboard
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="editReviewerProfile" disabled>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="4"
        md="6"
        class="my-0 py-0"
        v-if="!settingsLoading && isReviewer && settingsErrorMsg == ''"
      >
        <v-card class="mt-2 mb-2">
          <v-app-bar flat color="rgba(0, 0, 0, 0)">
            <v-toolbar-title class="text-overline">Payments</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-card-text>
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-bank</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Bank settings</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-credit-card-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Other settings</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="editPayments" disabled>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog scrollable v-model="dialog" max-width="400px" height="300px">
      <v-card>
        <v-card-title class="text-h5"> Change password </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                label="Current password"
                type="password"
                v-model="oldPassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="New password"
                type="password"
                v-model="newPassword"
                :rules="passwordRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <p
                class="mb-0 mt-1"
                style="color: #b71c1c; line-height: 12px"
                v-if="changePasswordError"
              >
                {{ changePasswordError }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="changePassword()"
            :loading="changePasswordBtnLoading"
            :disabled="changePasswordBtnLoading"
          >
            Change password
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      editReviewerProfile: false,
      editPayments: false,
      oldPassword: "",
      newPassword: "",
      changePasswordError: "some error",
      changePasswordBtnLoading: false,
      snackbar: false,
      snackbarText: "",
      passwordRules: [
        (value) => {
          if (value.length < 6)
            return "Password needs to have at least 6 characters";
          return true;
        },
      ],
      userEmail: "",
      isReviewer: false,
      reviewerStatus: "",
      reviewerProfileExperienceOk: false,
      reviewerProfileLinkedinUrlOk: false,
      reviewerProfilePaymentsOk: false,
      settingsLoading: true,
      settingsErrorMsg: "",
      isPro: false,
      proSubscription: {},
      cancelSubscriptionLoading: false,
    };
  },
  methods: {
    async changePassword() {
      this.changePasswordError = "";
      this.changePasswordBtnLoading = true;
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/changePassword",
          {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
          },
        );
        this.oldPassword = "";
        this.newPassword = "";
        this.snackbarText = "Password changed";
        this.snackbar = true;
        this.dialog = false;
      } catch (error) {
        this.changePasswordError = error;
      } finally {
        this.changePasswordBtnLoading = false;
      }
    },
    async getSettings() {
      this.settingsLoading = true;
      try {
        var response = await this.$utils.callBackendPost(
          this,
          "/api/getSettings",
          {
            proOption: this.selRadio,
          },
        );
        this.userEmail = response.email;
        this.isReviewer = response.isReviewer;
        this.reviewerProfileExperienceOk = response.revExperienceOk;
        this.reviewerProfileLinkedinUrlOk = response.revLinkedinUrlOk;
        this.reviewerProfilePaymentsOk = response.revPaymentsOk;
        this.reviewerStatus = response.reviewerStatus;
        this.isPro = response.isPro;
        this.proSubscription =
          response && response.proSubscription ? response.proSubscription : {};
        console.log(
          "burny! getSettings response: " + JSON.stringify(response, null, 2),
        );
      } catch (error) {
        this.settingsErrorMsg = error;
      } finally {
        this.settingsLoading = false;
      }
    },
    async cancelSubscription() {
      const promptText =
        "Are you sure you want to cancel your Pro subscription?";
      if (!confirm(promptText)) {
        return;
      }
      this.cancelSubscriptionLoading = true;
      try {
        await this.$utils.callBackendPost(this, "/api/cancelProStatus");
        this.$utils.trackEvent("unsubscribe_pro");
        this.getSettings();
      } catch (error) {
        this.snackbarText = error;
        this.snackbar = true;
      } finally {
        this.cancelSubscriptionLoading = false;
      }
    },
  },
  mounted() {
    this.getSettings();
    this.$utils.visit(this);
  },
};
</script>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
</style>
